import { createFeatureSelector, createSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../../store/store-keys'
import { IProjectState } from './project.reducers'
import cloneDeep from 'lodash/cloneDeep'

export const selectProjectFeature =
    createFeatureSelector<Readonly<IProjectState>>(StoreKeysEnum.AdminProjectFeature)

export const selectSchemaLvList = createSelector(
    selectProjectFeature,
    (data) => cloneDeep(data.schema.lvList)
)

export const selectSchemaAreaList = createSelector(
    selectProjectFeature,
    (data) => cloneDeep(data.schema.areaList)
)

export const selectSchema = createSelector(
    selectProjectFeature,
    (data) => cloneDeep(data.schema)
)

export const selectConcernedSubjectList = createSelector(
    selectProjectFeature,
    (data) => cloneDeep(data.schema.concernedSubjectList)
)

export const selectProjectJpv = createSelector(
    selectProjectFeature,
    (data) => data.anyJpv
)

export const selectProject = createSelector(
    selectProjectFeature,
    (data) => cloneDeep(data.schema.project)
)

export const selectParList = createSelector(
    selectProjectFeature,
    (data) => cloneDeep(data.schema.parList)
)

export const selectSubjectKnList = createSelector(
    selectProjectFeature,
    (data) => cloneDeep(data.schema.subjectKnList)
)

export const selectSubjectLpisList = createSelector(
    selectProjectFeature,
    (data) => cloneDeep(data.schema.subjectLpisList)
)